import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicePage.css';

function SoftwareSystems() {
  const navigate = useNavigate();
  return (
    <div className="service-page">
      <header className="service-header">
        <h1>Software & E-commerce Systems</h1>
        <p>Custom software solutions including POS, school, hospital and e-commerce platforms.</p>
      </header>
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>
      <div className="service-container">
        <section className="service-section">
          <h3>Solutions</h3>
          <ul>
            <li>POS & retail systems</li>
            <li>School management platforms</li>
            <li>Hospital management systems</li>
            <li>E-commerce platforms and payment integrations</li>
          </ul>
        </section>

        <div className="service-cta">
          <a href="/contact">Discuss Your Project</a>
        </div>
      </div>
    </div>
  );
}

export default SoftwareSystems;
